(function () {
  'use strict';

  angular
    .module('dashboard.project.overview')
    .directive('dashboardProjectOverview', dashboardProjectOverview);

  dashboardProjectOverview.$inject = ['$timeout'];

  function dashboardProjectOverview($timeout) {
    var directive = {
      bindToController: true,
      controller: 'dashboardProjectOverviewCtrl',
      controllerAs: 'vm',
      template: require('../dashboard.project.overview/table.html'),
      link: link,
      restrict: 'E',
    };
    return directive;

    function link(scope, element, attrs, ctrl) {}
  }
})();
